import {
  OnboardingApplicationFeeForm,
  OnboardingEmploymentHistoryForm,
  OnboardingQuestionnaireForm,
  OnboardingReferencesForm,
  OnboardingCurrentAddressForm
} from "../typings/onboarding";

export enum OnBoardingRentIncomeEnum {
  "Income" = "Income",
  "Assisted" = "Assisted",
  "Both" = "Both",
}
export type OnBoardingRentIncomeType = keyof typeof OnBoardingRentIncomeEnum;

// Mirrors ManageContractorAdditionalDetailsForm.tsx's TAX_ID_LENGTH precedent -- Social
// Security Number is validated frontend-only (no backend length check, same as Contractor Tax ID).
export const SSN_LENGTH = 9;

// UserBaseBM / UserBaseVM echo fields that round-trip on save-then-refetch (Back → Next).
// Null leaves (esp. whatsAppOptInAt) make checkEmptyFieldsFunc fail with no visible UI field.
// Bare keys are for array sections (EmploymentHistory / References); dotted keys for nested objects.
export const userBaseEchoSkipKeys = [
  "whatsAppOptIn",
  "whatsAppOptInAt",
  "hasPassword",
  "fullName",
  "initials",
];

export enum OnboardingStepsEnums {
  BasicDetails = "BasicDetails",
  CurrentAddress = "CurrentAddress",
  RentIncomeCheck = "RentIncomeCheck",
  CreditCheck = "CreditCheck",
  EmploymentHistory = "EmploymentHistory",
  References = "References",
  Questionnaires = "Questionnaires",
  Signature = "Signature",
  ApplicationFees = "ApplicationFees",
  
}

// Here is where we can change the sequence of Onboarding steps
export const DefaultOnboardingStepsSequence = [
  //  OnboardingStepsEnums.Welcome,
  OnboardingStepsEnums.BasicDetails,
  OnboardingStepsEnums.CurrentAddress,
  OnboardingStepsEnums.RentIncomeCheck,
  OnboardingStepsEnums.CreditCheck,
  OnboardingStepsEnums.EmploymentHistory,
  OnboardingStepsEnums.References,
  OnboardingStepsEnums.Questionnaires,
  OnboardingStepsEnums.Signature,
  OnboardingStepsEnums.ApplicationFees,
  // OnboardingStepsEnums.Thankyou,
];

export const DefaultEmploymentHistory: OnboardingEmploymentHistoryForm = {
  employerName: "",
  startDate: "",
  endDate: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: ""
};
;
export const DefaultReferences: OnboardingReferencesForm = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  referenceType: "Employer",
};

export const DefaultCurrentAddress: OnboardingCurrentAddressForm = {
  unitNumber: "",
  address: {
    streetAddress: "",
    city: "",
    state: "",
    zip: "",
  },
  movingDate: "",
  movingReason: ""
}

export const DefaultQuestionnaire: OnboardingQuestionnaireForm = [];

export const DefaultFeeFormData: OnboardingApplicationFeeForm = {
  feeSubmitOptions: "Card",
  nameOnCard: null,
  accountNumber: null,
  routingNumber: null,
  cardNumber: null,
  billingZipCode: null,
  expiryDate: null,
  cvv: null,
  saveDetails: null,
  applicationFee: null
};
